/* Local dependencies */
import { Warehouse, WarehouseStatus } from '../../types';

export enum ListWarehousesActionTypes {
  LIST_WAREHOUSES = 'LIST_WAREHOUSES',
  LIST_WAREHOUSES_SUCCESS = 'LIST_WAREHOUSES_SUCCESS',
  LIST_WAREHOUSES_ERROR = 'LIST_WAREHOUSES_ERROR',
  LIST_WAREHOUSES_RESET_ERROR = 'LIST_WAREHOUSES_RESET_ERROR',
  LIST_WAREHOUSES_RESET_STATE = 'LIST_WAREHOUSES_RESET_STATE',
}

export interface ListWarehousesInput {
  filter?: {
    statuses?: WarehouseStatus[];
  };
  from?: number;
  query?: string;
  size?: number;
}

export interface ListWarehousesRequest {
  type: ListWarehousesActionTypes.LIST_WAREHOUSES;
  input: ListWarehousesInput;
}

export interface ListWarehousesSuccess {
  type: ListWarehousesActionTypes.LIST_WAREHOUSES_SUCCESS;
  warehouses: Warehouse[];
  total: number;
}

export interface ListWarehousesError {
  type: ListWarehousesActionTypes.LIST_WAREHOUSES_ERROR;
  error: Error;
}

export interface ResetListWarehousesError {
  type: ListWarehousesActionTypes.LIST_WAREHOUSES_RESET_ERROR;
}

export interface ResetListWarehousesState {
  type: ListWarehousesActionTypes.LIST_WAREHOUSES_RESET_STATE;
}

export type ListWarehousesAction =
  | ListWarehousesRequest
  | ListWarehousesSuccess
  | ListWarehousesError
  | ResetListWarehousesError
  | ResetListWarehousesState;
